import { Entity } from "typegraph";
import Field from "typegraph/dist/decorators/field/Field";


export class Topic {
	@Field()
	public id:number;
}

@Entity({one: "topicFeature", many: "topicFeatures", create: "topicFeatureCreate", update: "topicFeatureUpdate"})
export class TopicFeature {

	@Field()
	id: number;

	@Field()
	enabled: boolean = true;

	@Field({entity: Topic})
	topic: number;

	@Field()
	endDate: string;

}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/TopicFeature.ts